<div class="skl-users-sync-config" aria-hidden="true">
  <div class="skl-inline-copy">
    <app-skeleton width="72%" height="13px" borderRadius="3px" marginBottom="8px"></app-skeleton>
    <app-skeleton width="56%" height="13px" borderRadius="3px" marginBottom="20px"></app-skeleton>
  </div>

  <div class="skl-inline-grid">
    <div>
      <app-skeleton width="160px" height="13px" borderRadius="3px" marginBottom="10px"></app-skeleton>
      <app-skeleton width="100%" height="40px" borderRadius="4px" marginBottom="0"></app-skeleton>
    </div>

    <div class="skl-inline-actions">
      <app-skeleton width="92px" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
      <app-skeleton width="88px" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
    </div>
  </div>
</div>